/* unplugin-vue-components disabled */import { render } from "./List.vue?vue&type=template&id=3a5d00dc&scoped=true&ts=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=3a5d00dc&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5d00dc"]])

export default __exports__